import React from 'react';

const CheckApplicationStatus = (props) => {

  return (
    <div>
      <div className="bg-image d-flex justify-content-center align-items-center bannerCheckStatus">
      </div>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 text-center">
              <h3>T-Mobile Sub-Dealer Application Status Tracker</h3>
              <p className="pHeading">
                Let us check where your T-Mobile Sub-Dealer application is in the process. <br className="hiddenTab" />
                Enter your information below & Submit
              </p>
            </div>
          </div>

          <br className="hiddenTab" />
          <div className="row">
            <div className="col-sm-12 text-center">
              <form onSubmit={props.handleSubmit}>
                <div className="form-group checklistForm">
                  <input
                    type="text"
                    name="email"
                    className="form-control"
                    placeholder="Enter your corporate email address"
                    value={props.email}
                    onChange={props.handleInputChange}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        props.handleSubmit(e);
                      }
                    }}
                  />
                  <button type="submit"
                    disabled={props.loading} className="btn btn-sm btn-primary primaryBtn">
                    SUBMIT
                  </button>
                  {props.error && <p className="text-danger">{props.error}</p>}
                  {props.showButton && (<div className='statusbtnnew'>Click To Check Your Status</div>)}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CheckApplicationStatus;
